"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.casesContract = exports.PaginatedHighlightedCase = exports.HighlightedCase = exports.SearchCasesQueryParams = exports.PaginatedCases = exports.GetCasesQueryParams = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const refine_1 = require("./util/refine");
const c = (0, core_1.initContract)();
const GetCasesQueryParamsSchema = resources_1.PaginationQueryParamsSchema.merge(resources_1.SortDirectionQueryParamsSchema).merge(zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
}));
exports.GetCasesQueryParams = GetCasesQueryParamsSchema.refine((refine_1.is));
const PaginatedCasesSchema = (0, resources_1.createPaginatedResponseSchema)(resources_1.Case);
exports.PaginatedCases = PaginatedCasesSchema.refine((refine_1.is));
const SearchCasesQueryParamsSchema = resources_1.PaginationQueryParamsSchema.merge(zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
    searchTerm: zod_1.default.string(),
}));
exports.SearchCasesQueryParams = SearchCasesQueryParamsSchema.refine((refine_1.is));
const HighlightedCaseSchema = resources_1.Case.and(resources_1.HighlightedAndScored);
exports.HighlightedCase = HighlightedCaseSchema.refine((refine_1.is));
const PaginatedHighlightedCaseSchema = (0, resources_1.createPaginatedResponseSchema)(exports.HighlightedCase);
exports.PaginatedHighlightedCase = PaginatedHighlightedCaseSchema.refine((refine_1.is));
const multiplePath = '/cases';
exports.casesContract = c.router({
    getCases: {
        method: 'GET',
        path: multiplePath,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: exports.PaginatedCases,
            [400]: resources_1.ErrorResponse,
            [401]: resources_1.ErrorResponse,
            [403]: resources_1.ErrorResponse,
        },
        query: exports.GetCasesQueryParams,
        summary: 'Retrieve cases for a court system',
    },
    searchCases: {
        method: 'GET',
        path: `${multiplePath}/search`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: exports.PaginatedHighlightedCase,
            [400]: resources_1.ErrorResponse,
            [401]: resources_1.ErrorResponse,
            [403]: resources_1.ErrorResponse,
        },
        query: exports.SearchCasesQueryParams,
        summary: 'Search cases within a court system',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
});
